import api from './../api/authApi'

import useAuth from './useAuth'
const ClearToken = () => {
const {user}=useAuth()
const remove=async()=>{
const response=await api.patch('logout',{
               refreshToken:user.refreshToken
        })
        return response.data}
 return remove
}
export default ClearToken;